module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.margin-small {\r\n    padding: 0px 0px 0px 0px !important;\r\n    margin: -12px 0px auto;\r\n}\r\n\r\n.margin-small:nth-child(odd){\r\n    background: white;\r\n}\r\n\r\n.margin-small:nth-child(even){\r\n    background: white;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-masters/allowance-codes/allowance-code/allowance-code.component.css
// module id = ./src/app/hrms/payroll/payroll-masters/allowance-codes/allowance-code/allowance-code.component.css
// module chunks = main